import React from 'react';

const HomePage = () => {
  return <div id='bg'></div>;
};

export default HomePage;
